module.exports = {
  // Name of your site. Can be the name of a brand, or your personal name.
  title: 'Every One Need One More Watch',
  // What's the purpose of this website? What can we expect from it?
  description:
    `One More Watches supply many brands watch, including Benyar watch, Curren watch, Cadisen Watch, Megir watch, Starking Watch, Naviforce watch, Pagani Design Watch, Skmei Watch.`,
  // Your legal name.
  legalName: 'One More Watches',
  // URL to this website. If you bought `www.domain.com`, then it will be `www.domain.com`.
  url: 'https://www.onemorewatches.com',
  // Favicon that will display on browsers.
  logo: 'static/images/favicon.png',
  // Who made this website?
  author: 'Juan Alejandro Morais',
  // What's the website of the author?
  authorUrl: 'https://www.onemorewatches.com',
  // Your social media presence, in the form of usernames.
  social: {
    // tells the Instagram API the username to get posts from. 
    // If the url is `https://www.instagram.com/natgeotravel`, your username is `natgeotravel`.
    instagram: '10187426296', 
    // Optional
    facebook: '@onemorewatches',
  },
  socialLinks: {
    // Complete URL verison of `social.instagram`.
    instagram: 'https://www.instagram.com/onemorewatches',
    // Optional
    facebook: 'https://www.facebook.com/onemorewatches',
    pinterest: 'https://www.pinterest.com/onemorewatches',
    twitter: 'https://www.twitter.com/onemorewatches',
    tumblr: 'https://onemorewatches.tumblr.com',
  },
  // If applicable, your Google Analytics crawl ID.
  googleAnalyticsId: 'UA-XXXXXXXX-X',
  // Colours that represent your website.
  themeColor: '#000',
  backgroundColor: '#fff',
  // No more information than City + Country due to privacy concerns.
  address: {
    city: 'City',
    country: 'Country',
  },
  // Basic contact details.
  contact: {
    // Email address to contact you.
    email: 'support@onemorewatches.com',
  },
  // When was this website created?
  foundingDate: '2020',
};
